import type * as ents from '@attain-apps/entities'

import type { Feature } from './feature'
import type { State } from './state'

export class Selectors {
  /** @see {@link State.widgetAliasLookup} */
  private readonly _widgetAliasLookup

  /**
   * Returns the {@link ents.core.mosaic.Widget.Id} that corresponds to the given
   * {@link ents.core.common.FlexibleIdentifier}. When given an alias, returns
   * the mapped {@link ents.core.mosaic.Widget.Id}. When given an ID directly,
   * returns that ID. Returns `undefined` if no valid ID is found.
   */
  public readonly getWidgetId
  constructor(feature: Feature) {
    this._widgetAliasLookup = feature.state.project(
      state => state.widgetAliasLookup,
    )

    this.getWidgetId = feature.createSelectorMethod(
      ({
        alias,
        id,
      }: ents.core.common.FlexibleIdentifier<ents.core.mosaic.Widget.Id>) =>
        this._widgetAliasLookup.project(
          widgetAliasLookup =>
            id ?? (alias ? widgetAliasLookup[alias] : undefined),
        ).asSelector,
    )
  }
}
